import { useDispatch, useSelector } from 'react-redux';
import { getConsentToProcessMessage } from '../gdpr/selectors/getConsentToProcessMessage';
import { getCookieConsentPromptMessage } from '../gdpr/selectors/getCookieConsentPromptMessage';
import { getShowGdprConsentToProcess } from '../gdpr/selectors/getShowGdprConsentToProcess';
// @ts-expect-error untyped file
import { getGdprConsentToProcessEnabledForChatflow } from '../gdpr/selectors/getGdprConsentToProcessEnabledForChatflow';
import { getUserHasGivenConsentToProcess } from '../gdpr/selectors/getHasUserGivenConsentToProcess';
import { shouldRequireExplicitCookieConsent } from '../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
// @ts-expect-error untyped file
import { consentToProcess as onConsentToProcess } from '../gdpr/actions/visitorConsentsToProcess';
import { consentToCookies as onConsentToCookies } from '../gdpr/actions/visitorConsentsToCookies';
import { closeConsentToProcess as closeConsentToProcessAction } from '../gdpr/actions/visitorClosesConsentToProcess';
export function useConsentPromptData() {
  const dispatch = useDispatch();
  const consentToProcessMessage = useSelector(getConsentToProcessMessage);
  const showGdprConsentToProcessButton = useSelector(getShowGdprConsentToProcess);
  const renderCookieConsentPrompt = useSelector(shouldRequireExplicitCookieConsent);
  const cookieConsentPromptMessage = useSelector(getCookieConsentPromptMessage);
  const showingGdprProcess = useSelector(state => getGdprConsentToProcessEnabledForChatflow(state) && !getUserHasGivenConsentToProcess(state));
  const consentPromptEnabled = renderCookieConsentPrompt || showingGdprProcess || showGdprConsentToProcessButton;
  const consentToProcess = () => dispatch(onConsentToProcess());
  const consentToCookies = () => dispatch(onConsentToCookies());
  const closeConsentToProcess = () => dispatch(closeConsentToProcessAction());
  return {
    consentToProcessMessage,
    cookieConsentPromptMessage,
    showGdprConsentToProcessButton,
    showingGdprProcess,
    renderCookieConsentPrompt,
    consentToProcess,
    consentToCookies,
    closeConsentToProcess,
    consentPromptEnabled
  };
}